module.exports = __webpack_public_path__ + "assets/keypad-sounds/siren-875d36f36da8a5ddc078c96e42f45896.wav";